import React, { Component } from 'react';
import { Router } from "@reach/router";
import Landing from "./landing";
import NotFound from "./404";
import Tos from './tos';
// import Pro from './pro';

class AppPublic extends Component {
 
  render() {
    return (
      <>
        <Router>
          <NotFound default />
          <Landing path='/' />
          {/* <Pro path='go-pro' /> */}
          <Tos path='terms-of-service' />
        </Router>
      </>
    );
  }
};

export default AppPublic;
